/**
 * What is not built yet — the one place the tutorial (chapter 10) and the
 * editor placeholders read. A spec pins the phase list: shipping a phase
 * forces this file (and so the chapter) to change. Empty since Phase 9:
 * auto-send was the last rung; only the fine print is left.
 * For Media Devoted | Created By Ciro Autiero
 */
export interface RoadmapRung {
  phase: number;
  title: string;
  what: string;
  gate?: string;
}

export const ROADMAP: RoadmapRung[] = [];

/** Smaller gaps inside what is built. */
export const FINE_PRINT: string[] = [
  'Auto-generate never re-syncs drafts — a config change after the layout needs Generate',
  'A gateway’s daily capacity counts the generator’s own drops — SMS sent outside the generator on the same route are not counted',
  'Hour Optimizer drops take the container default amount and gateway strategy — they have no slot row to skip or disable',
  'A master config cannot follow another master config, and one cannot be deleted while containers follow it; a container’s values in a section it does not keep as its own are ignored',
  'Failed sends in a row, or one whose outcome is unknown, halt auto-send in every campaign group of the country until a person resumes it',
  'Hour rules act only while the Hour Optimizer is on; a rule judges the tracker’s past results, never today’s sends (that is the verdicts’ job)',
  'Rename or delete an hour tag on Tag Rules › Hours and every hour rule that tests it does nothing until it is pointed at another tag',
];
